var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SimpleForm',{attrs:{"autofocus":!_vm.autofocus,"onSubmit":_vm.login,"fields":[
			{
				label : 'Email address',
				name : 'email',
				type : 'email',
				autocomplete : 'username',
				required : true,
			},
			{
				label : 'Password',
				name : 'password',
				type : 'password',
				autocomplete : 'current-password',
				required : true,
			} ],"model":_vm.creds}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }